export const AVAILABLE_CARDS = [
    {
        "icon": "/public/assets/images/calendar.svg",
        "title": "Consulto generico",
        "description": "Richiedi una visita medica approfondita",
        "buttonRoute": "generic-consultation",
        "buttonText": "RICHIEDI",
        "type": "MCG",
        "service": "MEDICAL_CONSULTANCY"
    },
    {
        "icon": "/public/assets/images/hand-arm-heart.svg",
        "title": "Care Manager",
        "description": "Un supporto in più per la tua famiglia",
        "buttonRoute": "care-manager",
        "buttonText": "RICHIEDI",
        "type": "MCM",
        "service": "CARE_MANAGER"
    },
    {
        "icon": "/public/assets/images/psi-chair.png",
        "title": "Consulto Psicologo",
        "description": "Una consulenza per il tuo benessere psicologico",
        "buttonRoute": "psyco-pathway",
        "buttonText": "RICHIEDI",
        "type": "MPS",
        "service": "PSYCHOLOGIST"
    }     
];

export const APPOINTMENTS_MOCK = [
        {
            "accessKey": "1e09035f-0013-41f6-becb-19b9965bc557-579edf81-e2c2-4fe0-887c-8f4656ec5e4c",
            "individualId": "b33c4059-8c33-ef11-aecd-000d3a45f87a",
            "consultDate": "15/05/2025",
            "consultDateTime": "2025-05-15T12:32:50.8946505",
            "type": 1,
            "missionId": "21266287",
            "dossierCode": "0725060046564",
            "phoneNumber": "3456789292",
            "email": null,
            "timeZone": null,
            "message": "qwertyuiop",
            "specialist": null,
            "specialistId": 0,
            "timeSlot": null,
            "timeSlotId": 0,
            "creationDateTime": "15/05/2025 12.32",
            "medicalMessageResponse": "",
            "medicalInternalNotes": null,
            "operationCenterNotes": null,
            "closureDateTime": "15/05/2025 12.32",
            "mainSymptom": null,
            "status": "Awaiting",
            "consultType": "GenericPhone",
            "iConsultType": 0,
            "fullName": "papero pipero",
            "accountIndividualId": "b33c4059-8c33-ef11-aecd-000d3a45f87a",
            "individualFullName": null,
            "appointmentStartDate": null,
            "appointmentEndDate": null,
            "link": null,
            "consultRequestAvailabilities": [],
            "consultRequestId": 111,
            "nAppointment": 0,
            "medicalRecordDocuments": null,
            "time": "12.32",
            "statusText": "statusTable.awaiting"
        }
];


export const HEALTBOOKING_TEXT_MOCK = [
    {
        "icon": "/public/assets/images/mail.svg",
        "title": "Consulto specialistico",
        "description": "parla con un medico specialista",
        "buttonRoute": "specialist-consultation",
        "buttonText": "RICHIEDI",
        "type": "MCS",
        "service": "MEDICAL_CONSULTANCY"
    },
    {
        "icon": "/public/assets/images/hand-arm-heart.svg",
        "title": "Care Manager",
        "description": "Un supporto in più per la tua famiglia",
        "buttonRoute": "care-manager",
        "buttonText": "RICHIEDI",
        "type": "MCM",
        "service": "CARE_MANAGER"
    },
    {
        "icon": "/public/assets/images/user-notification.svg",
        "title": "Videoconsulto Generico",
        "description": "Una visita medica completa ovunque tu sia",
        "buttonRoute": "televisit-generic-booking",
        "buttonText": "RICHIEDI",
        "type": "MTG",
        "service": "TELEVISIT_GENERIC"
    },
    {
        "icon": "/public/assets/images/user-notification.svg",
        "title": "Videoconsulto Specialistico",
        "description": "Una visita medica completa ovunque tu sia",
        "buttonRoute": "televisit-specialist-booking",
        "buttonText": "RICHIEDI",
        "type": "MTS",
        "service": "TELEVISIT_SPECIALIST"
    },
    {
        "icon": "/public/assets/images/calendar.svg",
        "title": "Consulto generico",
        "description": "parla con un medico generico",
        "buttonRoute": "generic-consultation",
        "buttonText": "RICHIEDI",
        "type": "MCG",
        "service": "MEDICAL_CONSULTANCY"
    },
    {
        "icon": "/public/assets/images/psi-chair.png",
        "title": "Consulto Psicologo",
        "description": "Una consulenza per il tuo benessere psicologico",
        "buttonRoute": "psyco-pathway",
        "buttonText": "RICHIEDI",
        "type": "MPS",
        "service": "PSYCHOLOGIST"
    },
    {
        "icon": "/public/assets/images/first-visit-nut.svg",
        "title": "Consulto Nutrizionista",
        "description": "Una consulenza per la tua forma fisica",
        "buttonRoute": "nut-pathway",
        "buttonText": "RICHIEDI",
        "type": "Non fornito",
        "service": "NUTRITIONIST"
    },
    {
        "icon": "/public/assets/images/first-visit-nut.svg",
        "title": "Nutrizionista Primo Incontro",
        "description": "Migliora le tue abitudini alimentari in 3 tappe",
        "buttonRoute": "first-nut-pathway",
        "buttonText": "RICHIEDI",
        "type": "PMN",
        "service": "TREATMENT_PATH_NUT"
    },
    {
        "icon": "/public/assets/images/first-visit-psy.svg",
        "title": "Psicologo Primo Incontro",
        "description": "Ritrova il tuo benessere. Avvia il tuo cammino verso il benessere psicologico in 2 sedute.",
        "buttonRoute": "first-psyco-pathway",
        "buttonText": "RICHIEDI",
        "type": "PMP",
        "service": "TREATMENT_PATH_PSY"
    },
    {
        "icon": "/public/assets/images/vet-logo.svg",
        "title": "Consulto veterinario",
        "description": "Il parere di un esperto per la salute dei tuoi animali domestici",
        "buttonRoute": "vet-consultation",
        "buttonText": "RICHIEDI",
        "type": "MVT",
        "service": "VETERINARIAN"
    },
    {
        "title": "Percorso di cura",
        "buttonRoute": "discover-care-pathway"
    },
    {
        "title": "Percorso di cura",
        "buttonRoute": "care-pathway"
    }
];


export const FUNCTIONS_MOCK = [
    "PPP",
    "TSP",
    "TGP",
    "PMN",
    "MFA",
    "MMR",
    "MCK",
    "MCM",
    "MTS",
    "ASX",
    "MTG",
    "PMP",
    "RMR",
    "PNP",
    "PNF",
    "PPF"
];


